import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'stack', 'Stack', [["path",{"d":"M12 6l-8 4l8 4l8 -4l-8 -4"}],["path",{"d":"M4 14l8 4l8 -4"}]]);